var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPieChartIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.813,
    height: 27.813,
    viewBox: "0 0 27.813 27.813",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(-1221.939 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10018",
    "data-name": "Group 10018",
    transform: "translate(1221.939 135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,13.376V0H.448A13.385,13.385,0,0,1,13.376,12.922v.454Z",
    transform: "translate(14.437 0)",
    fill: "#f59064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M13.41,26.821A13.414,13.414,0,0,1,8.19,1.054,13.326,13.326,0,0,1,13.41,0c.149,0,.3,0,.448.007H13.41v13.4h13.4v-.455c.005.157.008.31.008.455a13.4,13.4,0,0,1-13.41,13.41Z",
    transform: "translate(0 0.993)",
    fill: "#3953fb"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPieChartIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pieChartIcon.cb8b3f3f.svg";
export { ForwardRef as ReactComponent };